import { SendEventProps } from '@fiverr-private/gig_page_context';

export const mpClickedSocialSharing = () =>
    ({
        eventName: 'Gig page share clicked',
    } satisfies SendEventProps);
